import HeroBottomComponentWrapper from './HeroBottomComponentWrapper'

export default HeroBottomComponentWrapper
